module.exports = __webpack_public_path__ + "media/images/G-03-e6f7f3368b918be0ebd0ed768f5bc961.svg";